import { type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { BODY, Bullet, Section } from './rules-typography';

export function AutoReply(): ReactNode {
  return (
    <Section title="6. Respuesta automática">
      <p className={BODY}>El bot responde así:</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>«Procesando…» mientras analiza.</Bullet>
        <Bullet>«Nuevo creador encontrado por ti» si es nuevo.</Bullet>
        <Bullet>
          «Ya encontrado» si otro jugador lo registró antes — descubrirás su @.
        </Bullet>
      </ul>
    </Section>
  );
}

function CategoryAndSex(): ReactNode {
  return (
    <li className="space-y-1">
      <p className={BODY}>
        <strong className="text-text-primary">Categoría y sexo</strong> — elige
        una de las del listado. Si es persona, indica hombre o mujer.
      </p>
    </li>
  );
}

function EmailLine(): ReactNode {
  return (
    <li className="space-y-1">
      <p className={BODY}>
        <strong className="text-text-primary">Email</strong> — busca en
        «Contactar» / correo electrónico y en la descripción de la bio.
      </p>
      <div className="flex items-start gap-sm">
        <AlertTriangle size={14} className="mt-0.5 shrink-0 text-brand-red" />
        <p className={BODY}>
          Si tiene email visible y no lo añades, te llevas strike.
        </p>
      </div>
    </li>
  );
}

function NotesLine(): ReactNode {
  return (
    <li className="space-y-1">
      <p className={BODY}>
        <strong className="text-text-primary">Notas</strong> — opcionales pero
        valoradas.
      </p>
      <ul className={`${BODY} space-y-1.5 pt-1`}>
        <Bullet>
          Obligatorio: si sigue a{' '}
          <strong className="text-text-primary">@ernestdift</strong>, déjalo
          escrito. No ponerlo es strike.
        </Bullet>
        <Bullet>
          Opcional: una línea útil para los Approachers de fase 2/3 («muy
          potente», «perfil clave», «brutal comunicación»…).
        </Bullet>
      </ul>
    </li>
  );
}

export function CompleteData(): ReactNode {
  return (
    <Section title="7. Completa los datos">
      <p className={BODY}>Tras enviar el link, el bot te pide tres campos:</p>
      <ol className="space-y-md">
        <CategoryAndSex />
        <EmailLine />
        <NotesLine />
      </ol>
    </Section>
  );
}
